module.exports = __webpack_public_path__ + "static/media/Образец на пълномощно.a352cc1e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Образец на пълномощно.pdf
// module id = 119
// module chunks = 0